import ds from 'Shared/ds';

export default class OrderListApi {
    static data = id => ds.get(this.#const.DATA, { Id: id });

    static products = (id, categoryId, brandId, pageSize) => ds.get(`/orderlist/${id}/products`, { categoryId, brandId, pageSize });

    static #const = {
        DATA: "/orderlist/data"
    };

    static Events = {
        ORDER_DOCUMENTS: "order-documents",
        RETURN_DOCUMENTS: "return-documents"
    };
}